import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/modals/');

export default function SolarPanels() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [activeRV, setActiveRV] = useState(0);
    const [activeOG, setActiveOG] = useState(0);
    const [swiperRV, setSwiperRV] = useState({ activeIndex: 0 });
    const [swiperGrid, setSwiperGrid] = useState({ activeIndex: 0 });

    const solarPanelsData = {
        rv: {
            [t('presale.product.modals.solar_panels_rv_swiper1_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_rv_swiper1_spec1'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec2'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec3'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec4'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec5'),
                ],
                img: ['sp_100w_rigid.webp', 'sp_100w_rigid.png'],
            },
            [t('presale.product.modals.solar_panels_rv_swiper2_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_rv_swiper2_spec1'),
                    t('presale.product.modals.solar_panels_rv_swiper2_spec2'),
                    t('presale.product.modals.solar_panels_rv_swiper2_spec3'),
                    t('presale.product.modals.solar_panels_rv_swiper2_spec4'),
                ],
                img: ['sp_100w_flexible.webp', 'sp_100w_flexible.png'],
            },
            [t('presale.product.modals.solar_panels_rv_swiper3_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_rv_swiper3_spec1'),
                    t('presale.product.modals.solar_panels_rv_swiper3_spec2'),
                    t('presale.product.modals.solar_panels_rv_swiper3_spec3'),
                    t('presale.product.modals.solar_panels_rv_swiper3_spec4'),
                ],
                img: ['sp_400w_portable.webp', 'sp_400w_portable.png'],
            },
        },
        offGrid: {
            [t('presale.product.modals.solar_panels_off_grid_swiper1_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_off_grid_swiper1_spec1'),
                    t('presale.product.modals.solar_panels_off_grid_swiper1_spec2'),
                    t('presale.product.modals.solar_panels_off_grid_swiper1_spec3'),
                ],
                img: ['sp_400w_rigid.webp', 'sp_400w_rigid.png'],
            },
            [t('presale.product.modals.solar_panels_off_grid_swiper2_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec1'),
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec2'),
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec3'),
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec4'),
                ],
                img: ['sp_400w_portable.webp', 'sp_400w_portable.png'],
            },
        },
    };

    const onSwiperSlideTo = (index: number, type: string) => {
        if (type === 'rv') {
            swiperRV?.slideTo(index);
        }
        if (type === 'grid') {
            swiperGrid?.slideTo(index);
        }
    };

    const renderSwiper = (data: any) => {
        const dom = [];
        for (const key in data) {
            const { specList, img } = data[key];
            dom.push(
                <SwiperSlide>
                    <div className="swiper-content">
                        <div className="spec-list">
                            {specList.map((item: any, index: number) => (
                                <div className="spec-item" key={index}>
                                    <div className="text">{item}</div>
                                </div>
                            ))}
                        </div>
                        <div className="product-img">
                            <EFPic name={[img[0], img[1]]} className="fullImgs" alt={key} />
                        </div>
                    </div>
                </SwiperSlide>,
            );
        }
        return dom;
    };

    return (
        <div className={`modal-solar-panels ${css.SolarPanelsModal}`}>
            <div className="solar-panels-box">
                <div className="rv">
                    <div className="left">
                        <div className="modal-title1">{t('presale.product.modals.solar_panels_title')}</div>
                        <div className="modal-title2">{t('presale.product.modals.solar_panels_rv_title')}</div>
                    </div>
                    <div className="right">
                        <div className="swiper-title">
                            <span className={`text t ${activeRV === 0 && 'active'}`} onClick={() => onSwiperSlideTo(0, 'rv')}>
                                {t('presale.product.modals.solar_panels_rv_swiper1_title')}
                            </span>
                            <span className="s t" aria-hidden="true">
                                &nbsp; /&nbsp;
                            </span>
                            <span className={`text t ${activeRV === 1 && 'active'}`} onClick={() => onSwiperSlideTo(1, 'rv')}>
                                {t('presale.product.modals.solar_panels_rv_swiper2_title')}
                            </span>
                            <span className="s t" aria-hidden="true">
                                &nbsp; /&nbsp;
                            </span>
                            <span className={`text t ${activeRV === 2 && 'active'}`} onClick={() => onSwiperSlideTo(2, 'rv')}>
                                {t('presale.product.modals.solar_panels_rv_swiper3_title')}
                            </span>
                        </div>
                        <Swiper
                            className="rv-swiper"
                            modules={[Autoplay]}
                            loop
                            slidesPerView={'auto'}
                            spaceBetween={30}
                            initialSlide={0}
                            preloadImages={false}
                            lazy={true}
                            centeredSlides={true}
                            grabCursor={true}
                            onSwiper={(swiper: any) => setSwiperRV(swiper)}
                            onSlideChange={(swiper: any) => setActiveRV(swiper?.activeIndex % 3)}
                            pagination={{
                                clickable: true,
                            }}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                        >
                            {renderSwiper(solarPanelsData.rv)}
                        </Swiper>
                    </div>
                </div>
                <div className="off-grid">
                    <div className="left">
                        <div className="modal-title1">{t('presale.product.modals.solar_panels_title')}</div>
                        <div className="modal-title2">{t('presale.product.modals.solar_panels_off_grid_title')}</div>
                    </div>
                    <div className="right">
                        <div className="swiper-title">
                            <span className={`text ${activeOG === 0 && 'active'}`} onClick={() => onSwiperSlideTo(0, 'grid')}>
                                {t('presale.product.modals.solar_panels_off_grid_swiper1_title')}
                            </span>
                            <span className="separator" aria-hidden="true">
                                &nbsp; /&nbsp;
                            </span>
                            <span className={`text ${activeOG === 1 && 'active'}`} onClick={() => onSwiperSlideTo(1, 'grid')}>
                                {t('presale.product.modals.solar_panels_off_grid_swiper2_title')}
                            </span>
                        </div>
                        <Swiper
                            className="off-grid-swiper"
                            modules={[Autoplay]}
                            loop
                            slidesPerView={'auto'}
                            spaceBetween={30}
                            initialSlide={0}
                            preloadImages={false}
                            lazy={true}
                            centeredSlides={true}
                            grabCursor={true}
                            onSwiper={(swiper: any) => setSwiperGrid(swiper)}
                            onSlideChange={(swiper: any) => setActiveOG(swiper?.activeIndex % 2)}
                            pagination={{
                                clickable: true,
                            }}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                        >
                            {renderSwiper(solarPanelsData.offGrid)}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}
